import { z } from "zod/v4";

import { ExperienceDtoSchema } from "../../dtos/experiences";
import { castToNumber } from "../../utils";

import {
  AnalyzeContext,
  BaseAnalyticsPayloadSchema,
  CastedTimes,
} from "./base";

// The request from BE > Analytics
export const CampaignAnalyticsPayloadSchema = BaseAnalyticsPayloadSchema.extend(
  {
    resourceType: z.literal("campaigns"),
    experienceId: z.string().nullable(),
    maxZScore: castToNumber.or(z.any()).nullable(),
    customEvents: z.string().array(),
  }
);

export type CampaignAnalyticsPayloadType = z.infer<
  typeof CampaignAnalyticsPayloadSchema
> & {
  maxZScore: number | null | string | undefined;
};

// The request from FE > Backend
export const AnalyzeCampaignRequestBodySchema =
  CampaignAnalyticsPayloadSchema.omit({
    shopifyDomain: true,
    latestRunTs: true,
    timezone: true,
  }).extend({
    experienceId: z.uuid().nullable(),
  });

export type AnalyzeCampaignRequestBodyType = z.infer<
  typeof AnalyzeCampaignRequestBodySchema
> &
  CastedTimes & { maxZScore: number | null | string | undefined };

const AnalyzeCampaignContextSchema = AnalyzeContext.extend({
  experience: ExperienceDtoSchema.optional(),
  experiences: ExperienceDtoSchema.array().optional(),
});

export type AnalyzeCampaignContextType = z.infer<
  typeof AnalyzeCampaignContextSchema
>;
